import { Button } from '@components';
import { CustomPaginationProps } from 'types/pagination';

import theme from '../../../themes/colors';

const NextPageButton = ({
  totalCount,
  limit,
  page,
  setPage
}: CustomPaginationProps) => {
  const pageCount = Math.ceil(totalCount / limit);

  const goToNext = () => {
    if (page < pageCount) setPage(page + 1);
  };

  const isDisabled = page === pageCount;

  return (
    <Button
      label="Next"
      handleClick={goToNext}
      disabled={isDisabled}
      variant="tertiary"
      size="medium"
      rightIconName="arrow-right-grey"
      rightIconStroke={isDisabled ? theme.grey : theme.content}
      labelStyle="!font-medium"
    />
  );
};

export default NextPageButton;
